import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import Breadcrumbs from "../../web/components/Breadcrumbs";
import VTCMenu from "../../web/components/VTCMenu";
import { useContext, useEffect, useState } from "react";
import { EnterpriseContext } from "./EnterpriseContext";
import EnterpriseService from "../../common/services/enterprise-service";
import { toast, ToastContainer } from "react-toastify";
import LoadingOverlay from "react-loading-overlay";
import { confirmWrapper } from "../ui/askConfirm";
import Select from "react-select";
import reactSelectCustomStyles from "../../common/plugins/reactSelectStyles";
import ReactSelectUserOption from "../ui/ReactSelectUserOption";
import truckyService from "../../common/services/trucky-service";
import classNames from "classnames";
import Tips from "../Tips";
import tipsList from "../../common/constants/tipsList";
import BoxDynamicAd from "../../ads/BoxDynamicAd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UsedVehiclesMarket from "./UsedVehiclesMarket";
import MaintenanceAlerts from "./MaintenanceAlerts";

export default function BuyVehicle({ container }) {
  const { globalContext, setGlobalContext } = useContext(EnterpriseContext);

  const company = globalContext.company;
  const member = globalContext.member;

  const [loading, setLoading] = useState(false);

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [currentBrand, setCurrentBrand] = useState(null);
  const [currentModel, setCurrentModel] = useState(null);
  const [members, setMembers] = useState([]);
  const [vehicleToEdit, setVehicleToEdit] = useState(null);
  const [vehicleType, setVehicleType] = useState("truck");
  const [membersIsLoading, setMembersIsLoading] = useState(false);
  const [garages, setGarages] = useState([]);
  const es = new EnterpriseService();
  const [currentVehicle, setCurrentVehicle] = useState({});
  const [market, setMarket] = useState("new");

  useEffect(() => {
    truckyService.setDocumentTitle("Buy new Vehicle");
  }, []);

  useEffect(() => {
    getBrands();
    setModels([]);
  }, [vehicleType]);

  useEffect(() => {
    if (currentBrand) {
      getModels();
    }
  }, [currentBrand]);

  useEffect(() => {
    if (currentModel) {
      if (garages.length == 0) getGarages();

      if (members.length == 0) {
        setMembersIsLoading(true);
        es.getMembers(company, { perPage: 9999 }).then((result) => {
          setMembers(result.data);
          setMembersIsLoading(false);
        });
      }
    }
  }, [currentModel]);

  const getGarages = async () => {
    const result = await es.getGarages(company);
    if (!result.message) setGarages(result);
  };

  const getBrands = async () => {
    const result = await es.getBrands(vehicleType);
    setBrands(result);
  };

  const getModels = async () => {
    const result = await es.getModels(currentBrand, vehicleType);
    setModels(result);
  };

  const save = async () => {
    if (
      await confirmWrapper(container.localeManager.strings.buyVehicleConf, {
        container: container,
      })
    ) {
      setLoading(true);
      const result = await es.buyNewVehicle(company, {
        ...currentVehicle,
        model_id: currentModel.id,
      });
      if (result.success) {
        setCurrentModel(null);
        toast.success(container.localeManager.strings.deal);
      } else {
        toast.error(result.message);
      }
      setLoading(false);
    }
  };

  return (
    <Row noGutters className="" id="enterpriseContainer">
      <VTCMenu active={"/vehicles"} container={container}></VTCMenu>
      <Col>
        <Row noGutters>
          <Col>
            <LoadingOverlay
              active={loading}
              spinner={
                <Spinner
                  color="primary"
                  style={{ width: "4rem", height: "4rem" }}
                ></Spinner>
              }
            >
              <Card className="h-100">
                <CardBody>
                  <Breadcrumbs
                    breadcrumbs={[
                      {
                        to: "/vtchub",
                        title: container.localeManager.strings.vtcHub,
                      },
                      {
                        to: "/vehicles",
                        title: container.localeManager.strings.fleet,
                      },
                      {
                        title: container.localeManager.strings.truckyDealership,
                      },
                    ]}
                  ></Breadcrumbs>
                  <div style={{ backgroundImage: "url(/assets/dealership.webp)", backgroundSize: "cover", backgroundPosition: "center" }} className="mb-3 rounded">
                    <div className="text-center text-white py-10 fs-1">
                      {container.localeManager.strings.truckyDealership}
                    </div>
                  </div>
                  <div className="w-100 mb-3">
                    <ButtonGroup className="w-100">
                      <Button
                        color={market == "new" ? "primary" : "secondary"}
                        onClick={() => setMarket("new")}
                      >
                        {container.localeManager.strings.newVehicles}
                      </Button>
                      <Button
                        color={market == "used" ? "primary" : "secondary"}
                        onClick={() => setMarket("used")}
                      >
                        {container.localeManager.strings.usedVehicles}
                      </Button>
                    </ButtonGroup>
                  </div>
                  {market == "new" && (
                    <>
                      <Row className="mb-3">
                        <Col>
                          <ButtonGroup>
                            <Button
                              color={
                                vehicleType == "truck" ? "primary" : "secondary"
                              }
                              onClick={() => setVehicleType("truck")}
                            >
                              {container.localeManager.strings.trucks}
                            </Button>
                            <Button
                              color={
                                vehicleType == "bus" ? "primary" : "secondary"
                              }
                              onClick={() => setVehicleType("bus")}
                            >
                              {container.localeManager.strings.bus}
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="mb-3">
                            {container.localeManager.strings.chooseBrand}
                          </div>
                          <div className="grid cols-4 no-gap">
                            {brands.map((b) => {
                              return (
                                <Card
                                  className={classNames({
                                    "bg-light": true,
                                    brand: true,
                                    "border-success":
                                      currentBrand != null &&
                                      b.id == currentBrand.id,
                                  })}
                                >
                                  <CardBody onClick={() => setCurrentBrand(b)}>
                                    <img
                                      className="img-fluid"
                                      alt={b.name}
                                      src={b.logo_url}
                                    />
                                  </CardBody>
                                </Card>
                              );
                            })}
                          </div>
                        </Col>
                        <Col>
                          {models.length > 0 && (
                            <>
                              <div className="mb-3">
                                {container.localeManager.strings.chooseModel}
                              </div>
                              <div className="grid cols-2 no-gap">
                                {models.map((b) => {
                                  return (
                                    <Card
                                      onClick={() => setCurrentModel(b)}
                                      className={classNames({
                                        "bg-light": true,
                                        model: true,
                                        "border-success":
                                          currentModel != null &&
                                          b.id == currentModel.id,
                                      })}
                                    >
                                      <CardBody>
                                        <img
                                          className="img-fluid"
                                          alt={b.name}
                                          src={b.photo_url}
                                        />
                                        <div className="d-flex justify-content-between align-items-center">
                                          <span>{b.name}</span>
                                          <span className="text-success">
                                            {container.localeManager
                                              .numeral(b.price)
                                              .format("0,0")}{" "}
                                            {company.currency}
                                          </span>
                                        </div>
                                      </CardBody>
                                    </Card>
                                  );
                                })}
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                      {currentModel && (
                        <>
                          <Row className="mt-3">
                            <Col>
                              {garages.length > 0 && (
                                <FormGroup>
                                  <Label>
                                    {
                                      container.localeManager.strings
                                        .chooseGarage
                                    }
                                  </Label>
                                  <Input
                                    type="select"
                                    onChange={(e) =>
                                      setCurrentVehicle({
                                        ...currentVehicle,
                                        garage_id: e.target.value,
                                      })
                                    }
                                  >
                                    <option>
                                      {
                                        container.localeManager.strings
                                          .pleaseSelectGarage
                                      }
                                    </option>
                                    {garages.map((g) => {
                                      return (
                                        <option value={g.id}>
                                          {g.city.name}
                                        </option>
                                      );
                                    })}
                                  </Input>
                                </FormGroup>
                              )}
                            </Col>
                            <Col>
                              {members.length > 0 &&
                                es.can(member, "vehicles.assign") && (
                                  <FormGroup>
                                    <Label>
                                      {
                                        container.localeManager.strings
                                          .assignedDriver
                                      }
                                    </Label>
                                    <Select
                                      styles={reactSelectCustomStyles}
                                      value={
                                        members.find(
                                          (m) =>
                                            m.id ===
                                            currentVehicle.assigned_to_user_id
                                        ) || null
                                      }
                                      isClearable={true}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      options={members}
                                      onChange={(e) =>
                                        setCurrentVehicle({
                                          ...currentVehicle,
                                          assigned_to_user_id: e ? e.id : null,
                                        })
                                      }
                                      components={{
                                        Option: ReactSelectUserOption,
                                      }}
                                      isLoading={membersIsLoading}
                                    ></Select>
                                  </FormGroup>
                                )}
                            </Col>
                          </Row>
                          {currentVehicle.garage_id && currentModel.id && (
                            <Row>
                              <Col>
                                <FormGroup className="mt-3">
                                  <Button onClick={save} color="primary">
                                    {container.localeManager.strings.buy}
                                  </Button>
                                </FormGroup>
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                    </>
                  )}

                  {market == "used" && (
                    <UsedVehiclesMarket container={container} />
                  )}
                </CardBody>
              </Card>
            </LoadingOverlay>
          </Col>
          <aside className="ad-column-placeholder">
            <Tips
              tipKey={tipsList.KEYS.ENTERPRISE_VEHICLES}
              localeManager={container.localeManager}
            ></Tips>
            <MaintenanceAlerts container={container} company={globalContext.company}></MaintenanceAlerts>
            <BoxDynamicAd container={container} className="my-3" />
          </aside>
        </Row>
      </Col>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Row>
  );
}
